module.exports = __webpack_public_path__ + "static/media/Lucius Malfoy 1.dc72d6ea.jpg";